export default __webpack_public_path__ + "images/Tapclicks.f2157ebf04b7b74d2a7ff7f816973170.svg";